import { gql } from '@apollo/client';

export const GET_CAMPAIGNS = gql`
  query listSearchCampaigns($input: ListSearchCampaignInput) {
    listSearchCampaigns(input: $input) {
      count
      campaigns {
        campaignId
        campaignName
        description
        bannerCount
        linkCount
        html5Count
        programId
      }
    }
  }
`;
